<template>
  <h1 :class="[classes]">
    {{ text }}
  </h1>
</template>

<script>
export default {
  name: 'HeadingComponent',
  props: {
    text: {
      required: true,
      type: String
    },
    classes: {
      required: false,
      type: String
    }
  }
}
</script>

<style scoped>
  h1 {
    word-break: break-word;
  }
</style>
